module.exports = __webpack_public_path__ + "static/media/corner.2f310e1e.svg";